import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { checkUserPermission } from "../../common/UserPermission";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import moment from "moment";
import Select from "react-select";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";

const Paymentlisting = ({ customerid }) => {
  let PERMISSION_EDIT = "/manage-customers/:id";
  let PERMISSION_DELETE = "delete-customers";

  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const [pagenumber, setPageNumber] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [filtertext, setFilterText] = useState("");
  const [ordercolumn, setOrderColumn] = useState("");
  const [currentorder, setCurrentOrder] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();


  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
    );
  };

  const handleChangeCustomStartingDate = (event) => {
   
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
    

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
   
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
      handleListData(
       
        startingDate,
        endingDate,
        columnFilters,
        globalFilter,
        pagination,
        sorting,
        salesTypeID,
        customerid
      );
    // }
  }, [salesTypeID, customerID, quickBookOptions,globalFilter, pagination, sorting, columnFilters]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM")
  }
  


  let columns = useMemo(() => [
    {
      header: "Sr No",
      accessorKey: "RowNumber",
    },
    {
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/sales-receipt/${row.original.SaleID}`}
          >
            {row.original.InvoiceNo}
          </Link>
        </>
      ),
     
    },
    {
      header: "Payment Date",
      accessorKey: "PaymentDate",
      Cell: ({ row }) => {
        return moment(row.original.Paymentdate).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    {
      header: "Type",
      accessorKey: "SalesType",
    },
    {
      header: "Payment Type",
      accessorKey: "Paymenttypename",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) => {
        return row.original.DueDate == null || row.original.DueDate == "0000-00-00" ? "" : moment(row.original.DueDate).format("YYYY-MM-DD")
      }
    },
    {
      header: "Sale Date",
      accessorKey: "SaleDate",
      Cell: ({ row }) => {
        return moment(row.original.SaleDate).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    {
      header: "Payment Amount",
      accessorKey: "Paymentamount",
      Cell: ({ row }) => {
        return parseFloat(row.original.Paymentamount).toFixed(2)
      }
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        return parseFloat(row.original.Total).toFixed(2)
      }
    },
   
  ]);

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [selectedRows, toggleCleared]);



  const handleListData = (
   
    startingdate,
    endingdate,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    salestypeid,
  ) => {
    setLoading(true);

    // salestypeid = salestypeid > 0 ? salestypeid : 0;
    // customerid = customerid > 0 ? customerid : 0;

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/salespaymentlist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${pagination.pageIndex + 1}&pagesize=${pagination.pageSize}&filtertext=${globalFilter == undefined ? "" : globalFilter}&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${sorting[0]?.desc === undefined
          ? "desc"
          : sorting[0]?.desc === true
            ? "desc"
            : "asc"}&customerid=${customerid}&&startdate=${startingDate}&enddate=${endingDate}&LocationID=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
       
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  return (
    <>
      <div className={"col-lg-10 col-md-12"}>
        <div className="card bg-white">
          <div className="d-flex  w-100 mr-2 mt-2">
           
            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              Date Filter:
              <Select
                defaultValue={quickBookOptions}
                onChange={(event) => {
                  handleQuickBookChange(event);
                }}
                options={options}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                // hideSelectedOptions={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select"
              />
            </div>
            {quickBookOptions?.value == 2 && (
              <>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom Start Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="StartDate"
                    name="StartDate"
                    onChange={(event) => handleChangeCustomStartingDate(event)}
                  />
                </div>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom End Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="EndDate"
                    name="EndDate"
                    onChange={(event) => handleChangeCustomEndingDate(event)}
                  />
                </div>
              </>
            )}
            {quickBookOptions?.value == 2 && (
              <div className="p-1 col-lg-1 col-md-6 col-sm-12 mt-4">
                <button
                  className="btn btn-dark"
                  onClick={() => handleSearchAccordingToDate()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
            )}
          </div>
          <div className="card-body">
            {/* {loading===true ? <img src="https://media1.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952aaofoxh8qm6a3zgph6qs4lb6g3th0j1mckaenmzo&ep=v1_gifs_search&rid=200w.gif&ct=g" class="text-right" alt=""/> : */}
            <div className="email-header">
              <div className="row">
                <div className="col-lg-15 top-action-left col-sm-20">
                  <div className="float-left table-responsive">
                 
                  <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    // enableRowSelection={listid === 4 ? false : true}
                    enableColumnOrdering
                    initialState={{
                      density: "compact",
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "state", desc: false }], //sort by state by default
                    }}
                  
                    muiPaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
                    // manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      isError
                        ? { 
                          color: 'error',
                          children: 'Error loading data',
                        }
                        : undefined
                    }
                    // onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={totalRows}
                    state={{
                      // columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                   
                  />

                    

                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Paymentlisting;
